const resources = {
    viewAllBenefits: 'Voir tous les privilèges',
    faqs: 'FAQ',
    pointsTitle: 'Accumulez des points',
    pointsDescription: 'Accumulez des points sur les achats admissibles.',
    birthdayGiftTitle: 'Cadeau d’anniversaire',
    birthdayGiftDescription: 'Choisissez un cadeau pendant votre mois d’anniversaire.',
    freeShippingTitle: 'Expédition standard gratuite',
    freeShippingDescription: 'Profitez de l’expédition standard gratuite sur les commandes admissibles.',
    savingsEventsTitle: 'Économies saisonnières',
    savingsEventsDescription: 'Profitez des économies Beauty Insider tout au long de l’année.',
    experiencesTitle: 'Expériences exclusives',
    experiencesDescription: 'Accédez à des expériences et des événements exclusifs aux membres.',
    vibSavingsTitle: 'Économies pour membres VIB',
    vibSavingsDescription: 'Profitez des avantages VIB pendant les événements d’économies saisonnières.',
    rougeSavingsTitle: 'Économies pour membres Rouge',
    rougeSavingsDescription: 'Profitez des avantages Rouge pendant les économies saisonnières.',
    earlyAccessTitle: 'Accès avant-première',
    earlyAccessDescription: 'Découvrez certains lancements et événements en avant-première.',
    beautyInsiderBenefitsTitle: 'Beauty Insider Benefits',
    featuredBenefitsTitle: 'Privilèges en vedette',
    featuredBenefitsAsInsiderTitle: 'Privilèges en vedette pour les membres Beauty Insider',
    featuredBenefitsAsVibTitle: 'Privilèges en vedette pour les membres VIB',
    featuredBenefitsAsRougeTitle: 'Privilèges en vedette pour les membres Rouge',
    featuredJoinPoints: 'Accumulez des points à chaque achat',
    featuredInsiderDiscount: 'Économies exclusives aux membres',
    featuredVibDiscount: 'Réduction de 15 % exclusive aux membres deux fois par an',
    featuredRougeDiscount: 'Réduction de 20 % exclusive aux membres deux fois par an',
    featuredPoints: 'Accumulez des points avec chaque achat',
    featuredVibPoints: 'Triplez vos points sur un achat deux fois par an',
    featuredRougePoints: 'Quadruplez vos points sur un achat deux fois par an',
    featuredFirstAccess: 'Accès privilégié aux nouveautés',
    featuredExclusiveGift: 'Cadeau exclusif avec achat',
    featuredFreeShipping: 'Expédition standard gratuite',
    featuredFreeShippingEveryTime: 'Expédition gratuite illimitée pour chaque achat',
    featuredBirthdayGift: 'Cadeau d’anniversaire gratuit',
    featuredBirthdayGiftSet: 'Ensemble-cadeau d’anniversaire gratuit',
    featuredPointsSavingsExperiences: 'Vos points = des économies et des expériences',
    nonBiTitle: 'Privilèges Beauty Insider',
    nonBiSubtitle: 'Adhérez à Beauty Insider pour accumuler des points, recevoir un cadeau d’anniversaire, profiter de l’expédition gratuite et accéder à des économies exclusives.',
    insiderTitle: 'Privilèges Beauty Insider',
    insiderSubtitle: 'Votre statut de membre Beauty Insider vous donne accès à des points, des cadeaux d’anniversaire et des économies exclusives aux membres.',
    vibTitle: 'Privilèges VIB',
    vibSubtitle: 'Votre statut de membre VIB comprend les privilèges Beauty Insider, auxquels s’ajoutent encore plus d’économies et d’événements.',
    rougeTitle: 'Privilèges Rouge',
    rougeSubtitle: 'Votre statut de membre Rouge comprend les plus grandes économies Beauty Insider et des expériences exclusives.',
    whenYouReachVib: 'Lorsque vous atteignez l’échelon VIB',
    whenYouReachVibDescription: 'Continuez à accumuler des points pour atteindre le statut VIB et profiter de réductions et d’expériences Beauty Insider encore plus intéressantes.',
    whenYouReachRouge: 'Lorsque vous atteignez l’échelon Rouge',
    whenYouReachRougeDescription: 'Continuez à accumuler des points pour atteindre le statut Rouge et profiter des plus grandes économies Beauty Insider et d’expériences exclusives.',
    creditCardHolderTitle: 'Vos privilèges en tant que titulaire de carte de crédit Sephora',
    creditCardHolderEarnRewards: 'Obtenez une remise de 4 % en récompenses de carte de crédit²',
    creditCardHolderEarnPoints: 'Accumulez 2 points par dollar dépensé¹',
    creditCardHolderFirstPurchase: '25 % de réduction sur votre premier achat Sephora¹',
    creditCardHolderCta: 'Afficher les détails de votre carte'
};

export default function getResource(label) {
    return resources[label];
}
